<div class="height-100pc background-background overflow-hidden flex-vertical">
  <!-- header -->
  <div class="flex-horizontal justify-space-between gap-12 padding-24 with-border-bottom">
    <div>
      <div class="headline-5">Faire une demande de documents</div>
      <div class="color-on-surface-medium">
        Parcourez les catégories et cochez les justificatifs souhaités. Votre sélection se construit dans le bordereau à droite.
      </div>
    </div>
    <oui-button
      type="icon"
      color="secondary"
      (click)="documentRequestPanelService.closePanel()">
      <oui-icon>close</oui-icon>
    </oui-button>
  </div>

  <div class="flex-horizontal gap-16 padding-16 flex-1 min-height-0">
    <div class="flex-vertical flex-1 gap-12 min-height-0 min-width-0">
      <!-- searchbar -->
      <oui-searchbar
        class="padding-right-8"
        placeholder="Rechercher un document"
        [value]="search()"
        (valueChange)="search.set($event || '')"
        iconPrefix="search">
      </oui-searchbar>

      <div class="flex-horizontal flex-1 min-height-0">
        <!-- Categories -->
        <div class="flex-vertical categorie-panel">
          <div class="subtitle-1 color-on-surface-emphasis text-uppercase padding-16">Catégories</div>
          <div
            class="categorie-card"
            [ngClass]="selectedCategoryCode() === null ? 'selected oui-elevation-04 subtitle-2' : 'body-2'"
            type="button"
            (click)="selectCategory(null)">
            <div>Tous les documents</div>
            <div>{{ selectedCount() }}/{{ allDocumentsCount() }}</div>
          </div>
          @for (category of categories(); track category.value) {
            <div
              class="categorie-card"
              [ngClass]="selectedCategoryCode() === category.value ? 'selected oui-elevation-04 subtitle-2' : 'body-2'"
              type="button"
              (click)="selectCategory(category.value)">
              <div>{{ category.label }}</div>
              <div>{{ category.selected }}/{{ category.total }}</div>
            </div>
          }
        </div>
        <!-- Types -->
        <div class="flex-vertical flex-1 min-height-0 min-width-0 type-panel">
          <div
            class="type-heading color-on-surface-emphasis text-uppercase padding-vertical-16 flex-horizontal justify-space-between padding-left-24 padding-right-8">
            @if (selectedCategory()) {
              <div class="subtitle-1">{{ selectedCategory()?.label }}</div>
              <div class="subtitle-2">{{ selectedCategory()?.selected }}/{{ selectedCategory()?.total }} sélectionné(s)</div>
            } @else {
              <div class="subtitle-1">Tous les documents</div>
              <div class="subtitle-2">{{ selectedCount() }}/{{ allDocumentsCount() }} sélectionné(s)</div>
            }
          </div>
          <div class="type-list overflow-y-auto flex-1 min-height-0 flex-vertical gap-8 padding-left-24 padding-right-8 padding-bottom-8">
            @for (item of visibleItems(); track item.key) {
              <div
                class="type-card oui-elevation-04"
                [ngClass]="{ disabled: item.alreadyRequested, selected: item.selected }"
                (click)="setSelected(item.key, !item.selected)">
                @if (item.alreadyRequested) {
                  <oui-checkbox
                    [label]="item.label"
                    [control]="alreadyRequestedControl">
                  </oui-checkbox>
                } @else {
                  <oui-checkbox
                    [label]="item.label"
                    [value]="item.selected"
                    (click)="$event.stopPropagation()"
                    (valueChange)="setSelected(item.key, $event)">
                  </oui-checkbox>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Résumé -->
    <div class="resume-panel flex-vertical oui-elevation-04">
      <div class="padding-16 subtitle-1 color-on-surface-emphasis background-alert-pastel">Récapitulatif de la demande</div>
      <div class="flex-vertical flex-1 overflow-y-auto min-height-0">
        <!-- Destinataires (demande groupée) -->
        @if (isBulk()) {
          <div
            class="flex-horizontal flex-center justify-space-between padding-vertical-8 padding-lateral-16 subtitle-1 color-on-surface-medium">
            <div>Destinataires ({{ recipients().length }})</div>
            <oui-button
              type="icon"
              color="secondary"
              (click)="recipientsExpanded.set(!recipientsExpanded())">
              <oui-icon>{{ recipientsExpanded() ? 'expand_less' : 'expand_more' }}</oui-icon>
            </oui-button>
          </div>
          @if (recipientsExpanded()) {
            @for (recipient of recipients(); track recipient.id) {
              <div class="flex-horizontal flex-center gap-8 padding-16 with-border-bottom">
                <div class="recipient-avatar">{{ recipient.initials }}</div>
                <span class="flex-1 subtitle-2">{{ recipient.name }}</span>
                @if (recipients().length > 1) {
                  <oui-button
                    type="icon"
                    color="secondary"
                    (click)="removeRecipient(recipient.id)">
                    <oui-icon>close</oui-icon>
                  </oui-button>
                }
              </div>
            }
          }
        }
        <!-- Documents demandés / supplémentaires -->
        @if (selectedCount() > 0 || existingRequests().length === 0) {
          <div class="padding-16 subtitle-1">
            {{ existingRequests().length > 0 ? 'Documents supplémentaires' : 'Documents demandés' }} ({{ selectedRequests().length }})
          </div>
          @for (request of selectedRequests(); track request.entry.id) {
            <div class="flex-horizontal flex-center gap-4 padding-lateral-16 padding-vertical-4">
              <oui-icon>note_add</oui-icon>
              <oui-textfield
                class="flex-1 min-width-0"
                placeholder="Libellé du document"
                [control]="request.entry.control"
                [errors]="labelErrors"
                (valueChange)="updateLabel(request.item.key, request.entry.id, $event)">
              </oui-textfield>
              <div
                [ouiTooltip]="
                  request.item.entries.length >= maxRequestsPerDocument
                    ? maxRequestsPerDocument + ' exemplaires maximum par type de document'
                    : 'Dupliquer'
                ">
                <oui-button
                  type="icon"
                  color="secondary"
                  [disabled]="request.item.entries.length >= maxRequestsPerDocument"
                  (click)="duplicateRequest(request.item.key, request.entry.id)">
                  <oui-icon>add</oui-icon>
                </oui-button>
              </div>
              <oui-button
                type="icon"
                color="secondary"
                (click)="removeRequest(request.item.key, request.entry.id)"
                ouiTooltip="Supprimer">
                <oui-icon>delete</oui-icon>
              </oui-button>
            </div>
          } @empty {
            <div class="flex-vertical flex-1 flex-center justify-center gap-8 padding-16 text-center body-2 color-on-surface-medium">
              <oui-icon>draft</oui-icon>
              <div>
                <div>La demande est vide</div>
                <div><span class="subtitle-2 color-on-surface-emphasis">Cochez un document</span> pour l'ajouter ici.</div>
              </div>
              @if (!isBulk() && accessWithMagicLink()) {
                <div>
                  Ou <span class="subtitle-2 color-on-surface-emphasis">ouvrez un espace de dépôt</span> : votre investisseur pourra y
                  déposer les documents de son choix.
                </div>
              }
            </div>
          }
        }
        <!-- Documents en attente -->
        @if (existingRequests().length > 0) {
          <div class="padding-16 subtitle-1">Demande en cours ({{ existingRequests().length }})</div>
          @for (request of existingRequests(); track request.id) {
            <div class="flex-horizontal flex-center gap-8 padding-16 with-border-bottom">
              <oui-icon [class]="request.requestStatus.color">{{ request.requestStatus.icon }}</oui-icon>
              <div class="flex-vertical gap-4">
                <span class="subtitle-2">{{ request.label }}</span>
                <oui-tag
                  class="width-fit-content"
                  type="status"
                  [status]="request.requestStatus.tagStatus">
                  {{ request.requestStatus.label }}
                </oui-tag>
              </div>
            </div>
          }
        }
      </div>
      <!-- Enregistrement -->
      <div class="padding-16 with-border-top flex-vertical gap-8">
        <!-- Mode de notification (en demande groupée, toujours par email automatique) -->
        @if (!isBulk()) {
          @if (hasValidEmail()) {
            <oui-radio-list
              class="notification-choice"
              [value]="notifyByEmailChoice()"
              (valueChange)="notifyByEmailChoice.set($event)">
              <oui-radio-button [value]="true">
                <div class="flex-horizontal flex-wrap flex-center gap-4">
                  <span class="subtitle-2">Email automatique</span>
                  <oui-tag
                    type="status"
                    status="completed">
                    Recommandé
                  </oui-tag>
                </div>
              </oui-radio-button>
              <oui-radio-button [value]="false">
                <div class="subtitle-2">Je le préviens moi-même</div>
                <div class="caption color-on-surface-medium">
                  {{ accessWithMagicLink() ? 'Un lien de dépôt sécurisé vous sera fourni.' : 'Aucun email ne sera envoyé.' }}
                </div>
              </oui-radio-button>
            </oui-radio-list>
          } @else {
            <div class="caption color-on-surface-medium">
              L'investisseur n'a pas d'adresse email valide : pensez à le prévenir vous-même.
            </div>
          }
        }
        @if (notifyByEmail()) {
          <oui-button
            class="email-preview-button width-100pc"
            type="text"
            iconPrefix="visibility"
            [disabled]="submitDisabled() || saving()"
            (click)="openEmailPreview()">
            Voir l'aperçu de l'email
          </oui-button>
        }
        @if (saving()) {
          <oui-loading
            size="xs"
            class="align-self-center">
          </oui-loading>
        } @else {
          <oui-button
            class="width-100pc"
            type="contained"
            [disabled]="submitDisabled()"
            (click)="submit()">
            {{ submitLabel() }}
          </oui-button>
        }
      </div>
    </div>
  </div>
</div>
